import { lazy } from 'react';

import Loadable from '../components/Loadable';
import MinimalLayout from '../layout/MinimalLayout';
import AuthRedirectGuard from './AuthRedirectGuard';
import ErrorPage from '../pages/ErrorPage';

const AuthRegister = Loadable(lazy(() => import('../pages/authentication/Register')));
const AuthLogin = Loadable(lazy(() => import('../pages/authentication/Login')));
const ResetPassword = Loadable(lazy(() => import('../pages/authentication/ResetPassword')))
// const WorkspaceList = Loadable(lazy(()=>import('../pages/workspace/WorkspaceList')));
// const CreateWorkspace = Loadable(lazy(()=>import('../pages/workspace/CreateWorkspace')));
const MainPage = Loadable(lazy(()=>import('../pages/MainPage')));
const Onboarding = Loadable(lazy(() => import('../pages/authentication/Onboarding')));

const LoginRoutes = {
    path: '/',
    element: <MinimalLayout />,
    errorElement: <ErrorPage />,
    children: [
        {
            path: '/',
            element: <MainPage />
        },
        {
            path: '/register',
            element: <AuthRedirectGuard><AuthRegister /></AuthRedirectGuard>
        },
        {
            path: '/login',
            element: <AuthRedirectGuard><AuthLogin /></AuthRedirectGuard>
        },
        {
            path:'/onboarding',
            element:<Onboarding/>
        },
        {
            path:'/reset-password',
            element:<AuthRedirectGuard><ResetPassword/></AuthRedirectGuard>
        },
        {
            path: '/reset-password/code',
            element: <AuthRedirectGuard><ResetPassword /></AuthRedirectGuard>
        },
        {
            path: '/reset-password/send-code',
            element: <AuthRedirectGuard><ResetPassword /></AuthRedirectGuard>
        },
        {
            path: '/reset-password/change-password',
            element: <AuthRedirectGuard><ResetPassword /></AuthRedirectGuard>
        },
        // {
        //     path:'/space',
        //     element:<WorkspaceList/>
        // },
        // {
        //     path:'/space/create',
        //     element:<CreateWorkspace/>
        // },
    ]
}

export default LoginRoutes;